import { render, staticRenderFns } from "./HeaderPurchase.vue?vue&type=template&id=4e1bb024&scoped=true&"
import script from "./HeaderPurchase.vue?vue&type=script&lang=js&"
export * from "./HeaderPurchase.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPurchase.vue?vue&type=style&index=0&id=4e1bb024&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1bb024",
  null
  
)

export default component.exports